import { connect } from 'react-redux'
import IncomingWebhookDisplay from './IncomingWebhookDisplay'

const stateToProps = ({ numbers }, { node }) => ({
  number: numbers.numbersById[node.extras.numberSid],
  loading: numbers.numbersLoading,
})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(IncomingWebhookDisplay)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingWebhook/IncomingWebhookDisplay.container.js